/**
 * @desc ToB客户批量推送EBS
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(body: Array<string>, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/businessCustomer/pushCustomerInfoToEbs`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
